import React from "react";
// react admin
import { useGetIdentity } from "react-admin";
// mui
import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";

export const AccountInfo = () => {
  const { isPending, data } = useGetIdentity();

  // svg icons
  const UserAccount = "/Assets/Icons/user-account.svg";
  const DateJoined = "/Assets/Icons/calendar.svg";
  const LastLogin = "/Assets/Icons/login.svg";
  const TotalLogins = "/Assets/Icons/trend.svg";
  const Permissions = "/Assets/Icons/permissions.svg";

  // formate the date
  const formatDate = (isoDate) => {
    const date = isoDate ? new Date(isoDate) : null;
    return date && !isNaN(date.getTime())
      ? new Intl.DateTimeFormat("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }).format(date)
      : "N/A";
  };

  const rawData = [
    {
      id: 1,
      name: "Date Joined",
      value: formatDate(data?.createdAt),
      icon: DateJoined,
    },
    {
      id: 2,
      name: "Last Login",
      value: formatDate(data?.lastLogin),
      icon: LastLogin,
    },
    { id: 3, name: "Total Logins", value: data?.loginTimes, icon: TotalLogins },
    {
      id: 4,
      name: "Permissions",
      value: "Full Access",
      icon: Permissions,
    },
  ];

  return (
    <React.Fragment>
      {isPending ? (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Skeleton
              width="100%"
              height={100}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#FFF",
                  fontSize: 18,
                  fontWeight: 400,
                }}
              >
                Account Details
              </Typography>
              <Box
                sx={{
                  backgroundColor: "rgba(255, 215, 0, 0.20)",
                  padding: "8px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={UserAccount}
                  alt={UserAccount}
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "23px",
              }}
            >
              {rawData?.map((ele, index) => (
                <Box key={index + 1}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#999",
                      fontSize: 14,
                      fontWeight: 400,
                      mt: index === 0 ? 2 : 0,
                    }}
                  >
                    {ele?.name}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ele?.icon}
                      alt={index + 1}
                      style={{ width: 18, height: 18 }}
                    />
                    <Typography
                      variant="span"
                      sx={{
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: 400,
                        ml: 1,
                      }}
                    >
                      {ele?.value}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>
      )}
    </React.Fragment>
  );
};
